import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import './transition-container.scss';

const repaint = 50;

class TransitionContainer extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      height: 0,
      opacity: 0
    };
  }

  componentWillReceiveProps({ status }, nextState) {
    if (status === this.props.status) {
      return;
    }

    if (status === 'entering') {
      const time = this.props.duration / 2;

      const transitions = [
        `height ${time}ms ease ${time}ms`,
        `opacity ${time}ms ease ${time}ms`
      ];

      const styles = {
        opacity: 1,
        height: `${this.element.clientHeight}px`,
        transition: transitions.join(', ')
      };

      this.setState(styles);
    } else if (status === 'entered') {
      const styles = {
        height: 'auto',
        transition: 'none'
      };

      this.setState(styles);
    } else if (status === 'exiting') {
      let time = this.props.duration / 2;

      const callback = () => {
        const transitions = [
          `height ${time - repaint}ms ease`,
          `opacity ${time - repaint}ms ease`
        ];

        const styles = {
          opacity: 0,
          height: 0,
          transition: transitions.join(', ')
        };

        setTimeout(() => {
          this.setState(styles);
        }, repaint);
      };

      const styles = {
        height: `${this.element.clientHeight}px`
      };

      this.setState(styles, callback);
    }
  }

  render() {
    const { status } = this.props;

    return (
      <div
        className={cn('transition-container', status)}
        style={this.state}
      >
        <div ref={element => { this.element = element; }}>
          {this.props.children}
        </div>
      </div>
    );
  }
}

TransitionContainer.propTypes = {
  status: PropTypes.oneOf(['entering', 'entered', 'exiting', 'exited']),
  duration: PropTypes.number.isRequired
};

export default TransitionContainer;



// WEBPACK FOOTER //
// ./src/components/Layout/Navigation/TransitionContainer.js